// In production the React build is served from the same Cloud Function as the
// API, so use a relative path. For local `yarn start` on :3000 set
// REACT_APP_API_URL=http://localhost:8080/api in a .env.local.
export const API_URL = process.env.REACT_APP_API_URL || '/api';

export const IMG_PATH = `${process.env.REACT_APP_PUBLIC_URL || ''}/img`;

// Google OAuth client ID — set via REACT_APP_GOOGLE_CLIENT_ID at build time.
// Default falls back to the course.10xboost.org client so dev builds work.
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '16370168737-f1ju4kefeuc3a6lijrqes63s0im5rvq9.apps.googleusercontent.com';

// Kept for backwards compat with older code referencing `clientId` / `scope`.
export const clientId = GOOGLE_CLIENT_ID;
export const scope = 'openid email profile';

// trail url
export const TRAIL_URL = 'https://checkout.stripe.com/pay/cs_live_a1XIr7qZXiu1D4J2xnkeTlcus5IYLeuiWukCBmjdKZMTw4Drp6D6jeaXsP#fidkdWxOYHwnPyd1blppbHNgWjNiTFRkX3F8QHFGcEl%2FZjZSc0F2c0tBdTU1PEJ3MWxuMTQnKSd1aWxrbkB9dWp2YGFMYSc%2FJzFicjxBbjVQSzA8UGFjUjZmaicpJ3dgY2B3d2B3Jz8nbXFxdXY%2FKipycnIrYH9xanF3ZGFgK2ZqaConeCUl';